/**
 * Restauration : les horaires sont saisis dans Webflow, en toutes lettres.
 *
 * Un lieu porte le booléen `is-restauration` et une grille hebdomadaire d'une
 * ligne par jour, au format « Jour:XXhXX-XXhXX » :
 *
 *   Lundi:11h30-14h00,19h00-22h30
 *   Mardi:11h30-14h00
 *   Vendredi:11h30-14h00,20h00-02h00
 *   ...
 *   Dimanche:Fermé
 *
 * Plusieurs plages dans la journée se séparent par une virgule. Les minutes
 * peuvent être omises (« Lundi:11h-19h ») et la casse est libre (« LUNDI »,
 * « lundi »). Rien d'autre n'est toléré : ni espace, ni « à » à la place du
 * tiret, ni « 11:00 ». Une ligne hors format est ignorée, donc le jour compte
 * pour fermé — c'est ce que dit « Dimanche:Fermé », et c'est aussi ce que dit
 * une ligne absente.
 *
 * Une fin antérieure au début franchit minuit : « 20h00-02h00 » se lit « du
 * vendredi 20h au samedi 2h », et reste rangée au vendredi.
 *
 * C'est la seule source de vérité : plus de collection « days-schedules », donc
 * plus d'identifiants à maintenir ici quand un créneau change.
 */

/** Marque un lieu comme espace de restauration côté Webflow. */
export const RESTAURATION_FLAG = "is-restauration";

/**
 * Champs CMS où chercher la grille, dans l'ordre : le premier qui contient au
 * moins un jour lisible gagne. `horaires-d-ouverture` est déjà affiché sur la
 * fiche, donc la grille y est visible sans travail supplémentaire ; le champ
 * dédié n'est là que si l'on veut un jour séparer affichage et calcul.
 */
export const SCHEDULE_FIELDS = ["horaires-restauration", "horaires-d-ouverture"];

/** Index `Date.getDay()` par nom de jour, comparé sans accent ni casse. */
export const DAY_INDEX = {
    dimanche: 0,
    lundi: 1,
    mardi: 2,
    mercredi: 3,
    jeudi: 4,
    vendredi: 5,
    samedi: 6,
};

/** Libellés indexés par `Date.getDay()`, pour la phrase « ouvre lundi à 11h30 ». */
export const DAY_NAMES = [
    "dimanche",
    "lundi",
    "mardi",
    "mercredi",
    "jeudi",
    "vendredi",
    "samedi",
];

/** L'affichage démarre la semaine au lundi, pas au dimanche comme getDay(). */
export const DISPLAY_DAYS = [1, 2, 3, 4, 5, 6, 0];

export const MINUTES_IN_DAY = 24 * 60;
export const MINUTES_IN_WEEK = 7 * MINUTES_IN_DAY;
